<style lang="scss" scoped>
.no-activities-card {
    @media screen and (max-width: 575.98px) {
        width: 100% !important;
    }

    .bg {
        background-color: #f7f7f7;
        border-radius: 4px;
        position: absolute;
        top: 0px;
        bottom: 0px;
        left: 0px;
        right: 0px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &:hover {
            .plus-icon {
                transform: scale(1.15);
            }
        }

        .plus-icon {
            transition: transform 0.15s;
            content: url("/svg/plus-icon.svg");
        }

        .text {
            color: #172340;
            font-size: 1rem;
            font-weight: 500;
        }
    }
}
</style>

<template>
    <a class="no-activities-card d-block position-relative" :href="href" :style="{ 'height' : `${arHeight}px`, 'width' : `${arWidth}px` }">
        <div class=" w-100 h-100" :style="{ 'padding-top' : `${ (arHeight / arWidth) * 100 }%` }">
            <div class="bg">
                <div class="plus-icon mb-16"></div>
                <span class="text">{{ text }}</span>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: "elements.no-activities-card",

    props: {
        text: {
            type: String,
            required: false,
            default: "Activiteit"
        },
        href: {
            type: String,
            required: false,
            default: "/nl/activiteiten"
        },
        ratio: {
            type: [String, Boolean],
            default: '181:240',
            required: false
        },
        fixedWidth: {
            type: Boolean,
            default: false,
            required: false
        }
    },

    computed: {
        arWidth() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[0]
        },
        arHeight() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[1]
        },
    }
}
</script>